const SM4 = require("gm-crypt").sm4;

const sm4Config = {
    //配置sm4参数
    key: "aw89f7yaw98i2ujq",//这里这个key值是跟后端要的
    mode: "cbc", // 加密的方式有两种，ecb和cbc两种，也是看后端如何定义的，cbc还要加一个iv的参数，ecb不用
    cipherType: "base64", // 
    iv: "fasdy6f08f7ay6w0"// 这里key 和 iv 需要和后端保持一直
};


// 加密
export function encryptSm4(txt) {
    let sm4 = new SM4(sm4Config);
    return sm4.encrypt(txt) // 对数据进行加密
}